export const siteConfig = {
  name: "AI Compliance",
  thisUrl: process.env.BASE_URL?.startsWith("http")
    ? process.env.BASE_URL
    : "http://localhost:3000",
  url: process.env.DASHBOARD_BASE_URL?.startsWith("http")
    ? process.env.DASHBOARD_BASE_URL
    : "http://localhost:3000",

  // Root-relative on purpose. These are links into the application, which nginx serves
  // at /app on this same origin (nginx/prod.conf and nginx/default.conf), so a relative
  // path is correct everywhere this site runs.
  //
  // They used to be built from process.env.DASHBOARD_BASE_URL. next.config's `env`
  // inlines that at *build* time, while docker-compose.prod.yml supplies it at *run*
  // time and the homepage Dockerfile declares no build ARG — so the fallback was what
  // got compiled in, and the live marketing site at pixelcore.pixelboard.cc has been
  // sending visitors to http://localhost:3000/app/register and
  // http://localhost:3000/app/login: their own machine. Verified against the deployed
  // bundle. A relative path cannot acquire that class of bug.
  signUp: "/app/login",

  // Was /app/register. Public self-registration is closed: it created an active
  // is_staff administrator inside whichever tenant schema the request resolved to, so
  // the marketing site no longer has a route that hands out an account. Both the
  // primary CTA and the demo link now land on the booking flow, tagged so a lead can
  // be told apart from one raised inside the product.
  bookDemoUrl: "/app/book-demo?source=marketing",
  privacyPolicyUrl: "/privacy",
  termsOfServiceUrl: "/terms",
  docsUrl: "/docs",

  ogImage: "/seo.png",
  description:
    "AI-powered Governance, Risk & Compliance platform. Automate compliance assessments, manage risk registers, streamline audits, and enforce policies across ISO 27001, SOC 2, GDPR, EU AI Act, and more.",

  links: {
    twitter: "https://twitter.com/technozor",
    github: "https://github.com/technozor",
    linkedin: "https://linkedin.com/company/technozor",
    learnMore: "/app",
    email: "mailto:contact@technozor.com",
  },
};
